import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface EmailAttachmentInfoState {
  attachmentId: string | null
  emailId: string | null
  isAttachmentLoading: boolean
}

const initialState: EmailAttachmentInfoState = {
  attachmentId: null,
  emailId: null,
  isAttachmentLoading: false,
}

export const emailAttachmentInfoSlice = createSlice({
  name: 'emailAttachmentInfo',
  initialState,
  reducers: {
    setProcessEmailAttachmentAttachmentId: (state, action: PayloadAction<string>) => {
      state.attachmentId = action.payload
    },
    setProcessEmailAttachmentEmailId: (state, action: PayloadAction<string>) => {
      state.emailId = action.payload
    },
    setProcessEmailAttachmentIsAttachmentLoading: (state, action: PayloadAction<boolean>) => {
      state.isAttachmentLoading = action.payload
    },
  },
})

export const { setProcessEmailAttachmentAttachmentId, setProcessEmailAttachmentEmailId, setProcessEmailAttachmentIsAttachmentLoading } =
  emailAttachmentInfoSlice.actions

export const selectProcessEmailAttachmentAttachmentId = (state: RootState) => state.processDocument.emailAttachmentInfo.attachmentId
export const selectProcessEmailAttachmentEmailId = (state: RootState) => state.processDocument.emailAttachmentInfo.emailId
export const selectProcessEmailAttachmentIsAttachmentLoading = (state: RootState) => state.processDocument.emailAttachmentInfo.isAttachmentLoading
